import type { Config } from '../../_config'
import { FactoryDomain } from '../../_domain/FactoryDomain'
import { DomainError } from '../../_kernel/DomainError'
import { ErrorsCode } from '../../_kernel/ErrorsCode'
import type { Affiliate } from '../domain/Affiliate'
import type { Language } from '../domain/Language'
import type { ALLOWED_MARKETS } from '../domain/Market'
import { Market } from '../domain/Market'
import type { PartialSearch } from '../domain/PartialSearch'
import type { SharedRepository } from '../domain/SharedRepository'
import type { Source } from '../domain/Source'
import type { FeatureFlag } from '../domain/FeatureFlag'

export class DomainSharedRepository implements SharedRepository {
  static create({ config }: { config: Config }) {
    return new DomainSharedRepository(config)
  }

  constructor(private readonly config: Config) {}

  async market() {
    const domain = await FactoryDomain.create({ config: this.config }).domain()

    const [error, host] = domain.host<(typeof ALLOWED_MARKETS)[number]>()

    if (error) return Market.empty()

    return Market.fromHostName({ hostname: host })
  }

  async language(): Promise<Language> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async partialSearch(): Promise<PartialSearch> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async affiliate(): Promise<Affiliate> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async source(): Promise<Source> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async featureFlagByName(): Promise<FeatureFlag> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }
}
